import { Events } from 'global/constants';
import InkTonerDropdownStore from './InkTonerDropdownStore';
import InkTonerDropdownObserver from './InkTonerDropdownObserver';
import inkTonerConfig from './inkTonerConfig';
import { createInitialDropdownData } from './inkTonerDropdownUtility';

export default class InkTonerAssistedSearchManager {
	constructor(containerElement, assistedSearchIndex) {
		if (!containerElement) return new Error('Container element is undefined');
		this.containerElement = containerElement;
		this.inkTonerDropdownObservables = [];

		const initialDropdownData = createInitialDropdownData(inkTonerConfig);
		this.brandCheck(initialDropdownData);

		this.inkTonerDropdownStore = new InkTonerDropdownStore(
			assistedSearchIndex,
			initialDropdownData,
			this.containerElement,
		);

		Object.keys(inkTonerConfig).forEach(
			(dropdownElementReference, dropdownIndex) => {
				this.inkTonerDropdownObservables.push(
					new InkTonerDropdownObserver(
						containerElement,
						assistedSearchIndex,
						dropdownElementReference,
						dropdownIndex,
					),
				);
			},
		);

		this.inkTonerDropdownStore.publish(Events.INKTONER_STORE_CREATED);
	}

	brandCheck(initialDropdownData) {
		if (initialDropdownData.brand.options.length === 0) {
			this.containerElement.remove();
			throw new Error('No brand data available for selected brand ID');
		}
	}
}
